import { observer } from 'mobx-react'
import { ApiErrorTypes } from 'ogram-react'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

import { useMutation, useQuery, useStore } from '../../../utils/mst-hooks'
import { Separator } from '../../../components/app-layout/separator/separator'
import ShiftAttendanceItem from '../components/shift-attendance-item/shift-attendance-item'
import LoadingSpinner from '../../../components/loading-spinner/loading-spinner'
import './shifts-list.scss'
import { Header } from '../../../components/app-layout'
import { withErrorBoundary } from '../../../components/error/with-error-boundary'
import { shiftsListStore } from '../../../models-ui/shifts-list'
import { ShiftsFilters } from './components/shifts-filters/shifts-filters'

const ShiftsList = withErrorBoundary(
  observer(() => {
    const { fetchAttendanceReportJob, attendanceReportJobView, fetchShiftCancelReasons } = useStore().data

    const shifts = attendanceReportJobView()
    const [getShiftsResult, getShiftsQuery] = useMutation(
      () =>
        fetchAttendanceReportJob({
          clientLocationId: shiftsListStore.searchFilters.locationId,
          workCategoryId: shiftsListStore.searchFilters.workCategoryId,
        }),
      {
        filterError: [ApiErrorTypes.ClientError],
      },
    )

    const fetchCancelReasonsQuery = useQuery(fetchShiftCancelReasons)

    useEffect(() => {
      getShiftsQuery({})
    }, [])

    const { t } = useTranslation()

    const cancelReasonsLoaded = !fetchCancelReasonsQuery.isLoading

    return (
      <>
        {getShiftsResult.isLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="ShiftsList">
            <Header title={t('shifts_attendance_list.title')} />
            <Separator.Vertical height={28} />
            <ShiftsFilters onChange={() => getShiftsQuery({})} />
            <Separator.Vertical height={16} />
            {shifts.length ? (
              <div className="ShiftsList__list">
                {shifts.map(shift => (
                  <div className="ShiftsList__shiftItem" key={shift.id}>
                    <ShiftAttendanceItem shift={shift} cancelReasonsLoaded={cancelReasonsLoaded} />
                  </div>
                ))}
              </div>
            ) : (
              <p className="ShiftsList__hint">{t('shifts_attendance_list.empty_list')}</p>
            )}
          </div>
        )}
      </>
    )
  }),
)

export default ShiftsList
